import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Discover',
  desc: 'We start with a deep dive into your goals, audience, and brand ethos. I gather references and establish a clear creative direction.'
}, {
  num: '02',
  title: 'Design',
  desc: 'I explore concepts and build out the initial designs, focusing on typography, layout, and visual hierarchy to communicate your message.'
}, {
  num: '03',
  title: 'Refine',
  desc: 'Through collaborative feedback loops, we polish the designs. Every detail is scrutinized until the work aligns perfectly with your vision.'
}, {
  num: '04',
  title: 'Deliver',
  desc: 'You receive production-ready files, comprehensive guidelines, and assets optimized for both digital screens and physical print.'
}];
export function Process() {
  return <section id="process" className="py-24 md:py-32 bg-cream-dark/50" data-id="element-139">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-140">
        <div className="text-center mb-16 md:mb-24" data-id="element-141">
          <h2 className="text-5xl md:text-7xl font-serif tracking-tight mb-6" data-id="element-142">
            Working <span className="italic text-ink-light" data-id="element-143">Process</span>
          </h2>
          <p className="text-ink-light max-w-xl mx-auto" data-id="element-144">
            A streamlined, collaborative approach designed to deliver
            high-quality results without the agency overhead.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-145">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="relative" data-id="element-146">
              <div className="text-6xl font-serif text-ink/10 mb-6" data-id="element-147">
                {step.num}
              </div>
              <h3 className="text-2xl font-serif mb-4" data-id="element-148">{step.title}</h3>
              <p className="text-ink-light text-sm leading-relaxed" data-id="element-149">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}